var _defs, _circle, _path, _path2, _path3, _polygon;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSolutionsEducation(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    id: "Layer_1",
    viewBox: "0 0 66.14 61.1",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ff6e14;}.cls-2{fill:#544994;}.cls-3{fill:#281978;}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 55.26,
    cy: 37.74,
    r: 3.07
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m24.78,23.18h16.58c3.17,0,5.78,2.4,6.12,5.48l13.53-5.64-27.93-11.33L5.14,23.02l13.53,5.64c.34-3.08,2.95-5.48,6.12-5.48Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "m47.52,29.34c0-.23-.01-.45-.04-.67l-14.41,6.01-14.41-6.01c-.02.22-.04.45-.04.67v15.07h28.89v-15.07Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "m47.48,28.67c-.34-3.08-2.95-5.48-6.12-5.48h-16.58c-3.17,0-5.78,2.4-6.12,5.48l14.41,6.01,14.41-6.01Z"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "53.85 26.05 56.66 24.88 56.66 36.75 53.85 36.75 53.85 26.05"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSolutionsEducation);
export default __webpack_public_path__ + "static/media/Solutions_Education.d34787f0758348b950c46393610a26c7.svg";
export { ForwardRef as ReactComponent };